import { BuildingOffice2Icon, PlusIcon } from '@heroicons/react/24/solid';
import { Button, Link } from '@heroui/react';
import _ from 'lodash';
import { useEffect } from 'react';
import AccountsList from '@/app/components/account/accounts-list.tsx';
import { usePageLoading } from '@/app/components/page-loading.tsx';
import { useAuth } from '@/app/hooks/auth-provider';
import { Heading } from '@/primitives/heading.tsx';
import { useFetchVisibleAccountsQuery } from '@/slices/account-api-slice.ts';
import { type StaffMemberModel, StaffRoleEnum } from '../../../types/staff-member.type.ts';
import { UserTypeEnum } from '../../../types/user-type.ts';

export default function AccountList() {
  const { user } = useAuth();
  const { data, isLoading } = useFetchVisibleAccountsQuery(null);

  const { showPageLoading, hidePageLoading } = usePageLoading();

  useEffect(() => {
    isLoading ? showPageLoading('my-accounts-loading') : hidePageLoading('my-accounts-loading');
  }, [isLoading]);

  return (
    <>
      <div className='flex flex-row justify-between'>
        <Heading icon={<BuildingOffice2Icon className='size-7' />} className='pb-5'>
          Accounts
        </Heading>
        {(user?.userType === UserTypeEnum.Admin ||
          (user?.userType === UserTypeEnum.StaffMember &&
            (user as StaffMemberModel)?.accountSiteStaffMembers.some(
              x => x.staffRole.id === StaffRoleEnum.OrganizationAdministrator,
            ))) && (
          <div>
            <Button
              as={Link}
              variant='solid'
              color='primary'
              href={`/account/new/${_.head(data)?.organizationKey}`}
              startContent={<PlusIcon className='size-4' />}
            >
              Add Account
            </Button>
          </div>
        )}
      </div>
      <AccountsList accounts={data ?? []} />
    </>
  );
}
